<div class="dashboard">
  <div class="filter">
    <div class="row">
      <div class="col-md-12 col-xl-6">
        <usimweb-input [placeholder]="'Meshing filter'" [icon]="true" (input)="applyFilter($event)"></usimweb-input>
      </div>

      <div class="d-none d-md-block col-md-6 col-xl-3 filter-type">
        <usimweb-select
          class="filter-type-field"
          [label]="'Type'"
          [default]="filterType"
          [options]="appTypes"
          [empty]="true"
          (selectionChange)="filterTypeChangedEvent($event.value)"
        ></usimweb-select>
      </div>

      <div class="col-md-6 col-xl-3">
        <usimweb-checkbox
          class="filter-geo"
          [label]="'All geometries'"
          [tooltip]="'Show all geometries'"
          (onChange)="toggleGeometries($event)"
        ></usimweb-checkbox>
      </div>
    </div>
  </div>

  <div class="scroll-bar">
    <div class="row mt-4">
      <div class="col-sm-6 col-lg-6 col-xl-3 mb-3">
        <usimweb-projectcard
          [newProject]="true"
          [isMeshing]="true"
          [newCardTitle]="'New Mesh'"
          (openDialogEvent)="openAddCadDialog()"
        ></usimweb-projectcard>
      </div>

      <div
        class="col-sm-6 col-lg-6 col-xl-3 mb-3"
        *ngFor="let model of models | projects : filter | apptype : filterType"
      >
        <usimweb-projectcard
          [cardItem]="model"
          [isMeshing]="true"
          (selectEmitter)="openMesh($any($event))"
          (dialogEvent)="openDialog($any($event))"
        ></usimweb-projectcard>
      </div>
    </div>
  </div>
</div>
